(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1265px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile Search Toggle Logic
  document.addEventListener('DOMContentLoaded', () => {
    const searchContainer = document.querySelector('.header-search');
    const toggleBtn = document.querySelector('.header-search__toggle-mobile');
    const closeBtn = document.querySelector('.header-search__close-mobile');
    const searchInput = document.querySelector('.header-search .search__input');
    const searchModal = document.querySelector('.header__search');

    if (toggleBtn && searchContainer) {
      toggleBtn.addEventListener('click', () => {
        if (searchModal?.hasAttribute('open') && typeof searchModal.close === 'function') {
          searchModal.close(false);
        }

        searchContainer.classList.add('is-active');
        document.body.classList.add('search-active');
        setTimeout(() => searchInput.focus(), 400);
      });
    }

    if (closeBtn && searchContainer) {
      closeBtn.addEventListener('click', () => {
        searchContainer.classList.remove('is-active');
        document.body.classList.remove('search-active');
      });
    }

    // Cerrar al hacer click afuera
    document.addEventListener('click', (event) => {
      if (searchContainer && toggleBtn && searchContainer.classList.contains('is-active')) {
        const isClickInside = searchContainer.contains(event.target);
        const isClickOnToggle = toggleBtn.contains(event.target);
        
        if (!isClickInside && !isClickOnToggle) {
          searchContainer.classList.remove('is-active');
          document.body.classList.remove('search-active');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    if (!window.__cartMagnifyingLensBound) {
      window.__cartMagnifyingLensBound = true;

      if (!document.getElementById('liquidGlassSvgFilters')) {
        const globalSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        globalSvg.id = 'liquidGlassSvgFilters';
        globalSvg.setAttribute('width', '0');
        globalSvg.setAttribute('height', '0');
        globalSvg.setAttribute('style', 'position: absolute; pointer-events: none;');
        globalSvg.setAttribute('aria-hidden', 'true');
        document.body.insertBefore(globalSvg, document.body.firstChild);
      }

      class MagnifyingLensEngine {
        constructor(config = {}) {
          this.width = config.width || 750;
          this.height = config.height || 150;
          this.borderRadius = Math.min(this.width, this.height) / 2;
          this.bezelWidth = config.bezelWidth || 25;
          this.glassThickness = config.glassThickness || 1.0;
          this.refractiveIndex = config.refractiveIndex || 1.5;
          this.zoomStrength = config.zoomStrength || 1.0;
          this.refractionLevel = config.refractionLevel || 1.0;
          this.zoomRefractionBoost = config.zoomRefractionBoost || 1.35;
          this.sideRefractionScale = config.sideRefractionScale || 92;
          this.specularAngle = config.specularAngle || 48;
          this.specularOpacity = config.specularOpacity || 0.5;
          this.specularSaturation = config.specularSaturation || 9;
          this.displacementData = this._precalculateDisplacements();
          this.maxDisplacement = Math.max(...this.displacementData.map(Math.abs), 0.1);
        }

        _surfaceHeight(t) {
          t = Math.max(0, Math.min(1, t));
          return Math.sqrt(1 - Math.pow(1 - t, 2)) * this.glassThickness;
        }

        _surfaceNormal(t) {
          const delta = 0.001;
          const h1 = this._surfaceHeight(Math.max(0, t - delta));
          const h2 = this._surfaceHeight(Math.min(1, t + delta));
          const derivative = (h2 - h1) / (2 * delta);
          const length = Math.sqrt(derivative * derivative + 1);
          return { x: -derivative / length, y: 1 / length };
        }

        _calculateRefraction(normalizedDist) {
          if (normalizedDist >= 1) return 0;
          const normal = this._surfaceNormal(normalizedDist);
          const n1 = 1.0;
          const n2 = this.refractiveIndex;
          const cosTheta1 = Math.abs(normal.y);
          const sinTheta1 = Math.sqrt(1 - cosTheta1 * cosTheta1);
          const sinTheta2 = (n1 / n2) * sinTheta1;
          if (Math.abs(sinTheta2) > 1) return 0;
          return (sinTheta1 - sinTheta2) * this.bezelWidth * this.glassThickness;
        }

        _precalculateDisplacements() {
          const samples = 127;
          const magnitudes = [];
          for (let i = 0; i <= samples; i++) {
            magnitudes.push(this._calculateRefraction(i / samples));
          }
          return magnitudes;
        }

        _distanceFromBorder(x, y) {
          const w = this.width;
          const h = this.height;
          const r = this.borderRadius;
          let minDist = Infinity;

          if (x >= r && x <= w - r) minDist = Math.min(minDist, y, h - y);
          if (x < r) {
            const dx = x - r;
            const dy = y - h / 2;
            minDist = Math.min(minDist, r - Math.sqrt(dx * dx + dy * dy));
          }
          if (x > w - r) {
            const dx = x - (w - r);
            const dy = y - h / 2;
            minDist = Math.min(minDist, r - Math.sqrt(dx * dx + dy * dy));
          }

          return Math.max(0, minDist);
        }

        _angleFromBorder(x, y) {
          const w = this.width;
          const h = this.height;
          const r = this.borderRadius;
          let minDist = Infinity;
          let angle = 0;

          if (x >= r && x <= w - r) {
            if (y < minDist) {
              minDist = y;
              angle = Math.PI / 2;
            }
            if (h - y < minDist) {
              minDist = h - y;
              angle = -Math.PI / 2;
            }
          }

          if (x < r) {
            const dx = x - r;
            const dy = y - h / 2;
            const dist = r - Math.sqrt(dx * dx + dy * dy);
            if (dist >= 0 && dist < minDist) {
              minDist = dist;
              angle = Math.atan2(-dy, -dx);
            }
          }

          if (x > w - r) {
            const dx = x - (w - r);
            const dy = y - h / 2;
            const dist = r - Math.sqrt(dx * dx + dy * dy);
            if (dist >= 0 && dist < minDist) {
              minDist = dist;
              angle = Math.atan2(-dy, -dx);
            }
          }

          return angle;
        }

        generateBezelMap() {
          const canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          const ctx = canvas.getContext('2d');
          const imageData = ctx.createImageData(this.width, this.height);
          const data = imageData.data;

          for (let y = 0; y < this.height; y++) {
            for (let x = 0; x < this.width; x++) {
              const idx = (y * this.width + x) * 4;
              const dist = this._distanceFromBorder(x, y);
              if (dist >= this.bezelWidth || dist <= 0) {
                data[idx] = data[idx + 1] = 128;
                data[idx + 2] = 128;
                data[idx + 3] = 255;
                continue;
              }

              const t = dist / this.bezelWidth;
              const sampleIdx = Math.min(126, Math.floor(t * 127));
              const magnitude = this.displacementData[sampleIdx];
              const normalizedMag = this.maxDisplacement > 0 ? magnitude / this.maxDisplacement : 0;
              const angle = this._angleFromBorder(x, y);
              data[idx] = Math.round(128 + Math.cos(angle) * normalizedMag * 127);
              data[idx + 1] = Math.round(128 + Math.sin(angle) * normalizedMag * 127);
              data[idx + 2] = 128;
              data[idx + 3] = 255;
            }
          }

          ctx.putImageData(imageData, 0, 0);
          return canvas.toDataURL('image/png');
        }

        generateZoomMap() {
          const canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          const ctx = canvas.getContext('2d');
          const imageData = ctx.createImageData(this.width, this.height);
          const data = imageData.data;
          const centerX = this.width / 2;
          const centerY = this.height / 2;

          for (let y = 0; y < this.height; y++) {
            for (let x = 0; x < this.width; x++) {
              const idx = (y * this.width + x) * 4;
              const dist = this._distanceFromBorder(x, y);
              if (dist <= 0) {
                data[idx] = data[idx + 1] = 128;
                data[idx + 2] = 128;
                data[idx + 3] = 255;
                continue;
              }

              const dx = x - centerX;
              const dy = y - centerY;
              const distFromCenter = Math.sqrt(dx * dx + dy * dy);
              if (distFromCenter < 1) {
                data[idx] = data[idx + 1] = 128;
                data[idx + 2] = 128;
                data[idx + 3] = 255;
                continue;
              }

              const maxDist = Math.max(centerX, centerY);
              const normalizedDist = Math.min(distFromCenter / maxDist, 1);
              const zoomIntensity = normalizedDist * this.zoomStrength;
              const dirX = -dx / distFromCenter;
              const dirY = -dy / distFromCenter;
              data[idx] = Math.round(128 + dirX * zoomIntensity * 127);
              data[idx + 1] = Math.round(128 + dirY * zoomIntensity * 127);
              data[idx + 2] = 128;
              data[idx + 3] = 255;
            }
          }

          ctx.putImageData(imageData, 0, 0);
          return canvas.toDataURL('image/png');
        }

        generateSpecularMap() {
          const canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          const ctx = canvas.getContext('2d');
          const imageData = ctx.createImageData(this.width, this.height);
          const data = imageData.data;
          const angleRad = (this.specularAngle * Math.PI) / 180;
          const lightDir = { x: -Math.sin(angleRad), y: -Math.cos(angleRad), z: 0.5 };
          const lightLen = Math.sqrt(lightDir.x ** 2 + lightDir.y ** 2 + lightDir.z ** 2);
          lightDir.x /= lightLen;
          lightDir.y /= lightLen;
          lightDir.z /= lightLen;

          for (let y = 0; y < this.height; y++) {
            for (let x = 0; x < this.width; x++) {
              const dist = this._distanceFromBorder(x, y);
              const idx = (y * this.width + x) * 4;
              if (dist >= this.bezelWidth || dist <= 0) {
                data[idx] = data[idx + 1] = data[idx + 2] = data[idx + 3] = 0;
                continue;
              }

              const t = dist / this.bezelWidth;
              const normal2D = this._surfaceNormal(t);
              const angle = this._angleFromBorder(x, y);
              const normal3D = {
                x: Math.cos(angle) * normal2D.x,
                y: Math.sin(angle) * normal2D.x,
                z: normal2D.y,
              };
              const dot = normal3D.x * lightDir.x + normal3D.y * lightDir.y + normal3D.z * lightDir.z;
              const specular = Math.pow(Math.max(0, dot), 9);
              const edgeFade = 1 - Math.pow(t, 0.6);
              const intensity = Math.round(specular * edgeFade * this.specularOpacity * 255);
              data[idx] = data[idx + 1] = data[idx + 2] = intensity;
              data[idx + 3] = intensity;
            }
          }

          ctx.putImageData(imageData, 0, 0);
          return canvas.toDataURL('image/png');
        }

        applyToFilter() {
          const bezelMap = this.generateBezelMap();
          const zoomMap = this.generateZoomMap();
          const specularMap = this.generateSpecularMap();

          const magnifyingMap = document.getElementById('mgMagnifyingMap');
          const displacementMap = document.getElementById('mgDisplacementMap');
          const specularLayer = document.getElementById('mgSpecularMap');
          const zoomDisplacement = document.getElementById('mgZoomDisplacement');
          const bezelDisplacement = document.getElementById('mgBezelDisplacement');
          const saturationMatrix = document.getElementById('mgSaturationMatrix');
          const filterElement = document.getElementById('magnifying-glass-filter');

          if (filterElement) {
            filterElement.setAttribute('x', '0');
            filterElement.setAttribute('y', '0');
            filterElement.setAttribute('width', this.width);
            filterElement.setAttribute('height', this.height);
            filterElement.setAttribute('filterUnits', 'userSpaceOnUse');
          }

          if (magnifyingMap) {
            magnifyingMap.setAttribute('href', zoomMap);
            magnifyingMap.setAttribute('width', this.width);
            magnifyingMap.setAttribute('height', this.height);
          }
          if (displacementMap) {
            displacementMap.setAttribute('href', bezelMap);
            displacementMap.setAttribute('width', this.width);
            displacementMap.setAttribute('height', this.height);
          }
          if (specularLayer) {
            specularLayer.setAttribute('href', specularMap);
            specularLayer.setAttribute('width', this.width);
            specularLayer.setAttribute('height', this.height);
          }

          const sideScale = this.sideRefractionScale * this.refractionLevel;
          const zoomScale = sideScale * this.zoomRefractionBoost;

          if (bezelDisplacement) bezelDisplacement.setAttribute('scale', sideScale.toFixed(2));
          if (zoomDisplacement) zoomDisplacement.setAttribute('scale', zoomScale.toFixed(2));
          if (saturationMatrix) saturationMatrix.setAttribute('values', String(this.specularSaturation));
        }
      }

      function updateBoxShadowForDimensions(lens, containerDimensions) {
        const actualHeight = containerDimensions.height;
        const scale = actualHeight / 120;
        const shadowSpread1 = Math.round(1 * scale);
        const shadowBlur2 = Math.round(4 * scale);
        const shadowOffset2 = Math.round(9 * scale);
        const shadowInset1Offset = Math.round(2 * scale);
        const shadowInset1Blur = Math.round(24 * scale);
        const shadowInset2Offset = Math.round(2 * scale);
        const shadowInset2Blur = Math.round(24 * scale);
        const glassEl = lens.querySelector('.magnifying-lens-glass');

        if (glassEl) {
          glassEl.style.boxShadow = `
            0 0 0 ${shadowSpread1}px rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.16) 0px ${shadowBlur2}px ${shadowOffset2}px,
            rgba(0, 0, 0, 0.2) 0px ${shadowInset1Offset}px ${shadowInset1Blur}px inset,
            rgba(255, 255, 255, 0.2) 0px -${shadowInset2Offset}px ${shadowInset2Blur}px inset
          `;
        }
      }

      function updateMagnifyingLensEngine(lens) {
        const lensRect = lens.getBoundingClientRect();
        const containerDimensions = {
          width: Math.round(lensRect.width),
          height: Math.round(lensRect.height * 1.25),
        };

        updateBoxShadowForDimensions(lens, containerDimensions);

        const engine = new MagnifyingLensEngine({
          width: containerDimensions.width,
          height: containerDimensions.height,
          bezelWidth: Math.min(containerDimensions.width, containerDimensions.height) * 0.14,
          glassThickness: 1.0,
          refractiveIndex: 1.5,
          zoomStrength: 1.0,
          refractionLevel: 1.0,
          zoomRefractionBoost: 1.35,
          sideRefractionScale: 92,
          specularAngle: 48,
          specularOpacity: 0.5,
          specularSaturation: 9,
        });

        engine.applyToFilter();
      }

      function isElementVisibleInViewport(element) {
        if (!element) return false;

        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        return rect.bottom > 0 && rect.top < viewportHeight && rect.right > 0 && rect.left < viewportWidth;
      }

      function initMagnifyingLens() {
        const lens = document.getElementById('magnifyingLens');
        const summarySection = document.getElementById('main-cart-footer');
        const itemsSection = document.getElementById('main-cart-items');
        const headerWidthSource = document.querySelector(
          'sticky-header .header.page-width, .header-wrapper .header.page-width, .section-header .header.page-width'
        );
        let lensReady = false;
        let preloadStarted = false;

        if (!lens) return;

        if (document.body && lens.parentElement !== document.body) {
          document.body.appendChild(lens);
        }

        const syncLensVisibility = () => {
          const checkoutBtn = document.getElementById('checkout');
          const isCheckoutVisible = isElementVisibleInViewport(checkoutBtn);
          const isSummaryBelowProducts =
            summarySection &&
            itemsSection &&
            summarySection.getBoundingClientRect().top >= itemsSection.getBoundingClientRect().bottom - 2;

          if (lensReady && checkoutBtn && !checkoutBtn.disabled && isSummaryBelowProducts && !isCheckoutVisible) {
            lens.classList.add('visible');
            return;
          }

          lens.classList.remove('visible');
        };

        const syncLensWidth = () => {
          if (!headerWidthSource) return;
          const headerRect = headerWidthSource.getBoundingClientRect();
          if (!headerRect.width) return;
          const isTabletViewport = window.innerWidth >= 750 && window.innerWidth <= 1192;
          const targetWidth = isTabletViewport ? headerRect.width * 0.88 : headerRect.width;
          lens.style.width = `${Math.round(targetWidth)}px`;
        };

        const preloadMagnifyingLens = () => {
          if (preloadStarted) return;
          preloadStarted = true;

          const finishPreload = () => {
            syncLensWidth();
            updateMagnifyingLensEngine(lens);
            const finalizeReady = () => {
              lensReady = true;
              syncLensVisibility();
            };

            if (window.requestAnimationFrame) {
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(finalizeReady);
              });
            } else {
              setTimeout(() => setTimeout(finalizeReady, 0), 0);
            }
          };

          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(finishPreload);
          } else {
            setTimeout(finishPreload, 0);
          }
        };

        const testEl = document.createElement('div');
        testEl.style.backdropFilter = 'url(#test)';
        const supportsBackdropFilterURL = testEl.style.backdropFilter.includes('url');
        const glassEl = lens.querySelector('.magnifying-lens-glass');

        if (glassEl) {
          glassEl.style.display = 'block';
          glassEl.style.setProperty(
            'backdrop-filter',
            'blur(3px) saturate(1.24) brightness(1.04) url(#magnifying-glass-filter)',
            'important'
          );
          glassEl.style.setProperty(
            '-webkit-backdrop-filter',
            'blur(3px) saturate(1.24) brightness(1.04) url(#magnifying-glass-filter)',
            'important'
          );

          if (!supportsBackdropFilterURL) {
            glassEl.style.backdropFilter = 'blur(22px) saturate(190%) brightness(1.06) contrast(1.02)';
            glassEl.style.webkitBackdropFilter = 'blur(22px) saturate(190%) brightness(1.06) contrast(1.02)';
          }
        }

        preloadMagnifyingLens();
        syncLensVisibility();

        if (typeof ResizeObserver !== 'undefined' && headerWidthSource) {
          const headerResizeObserver = new ResizeObserver(() => {
            syncLensWidth();
            if (!lensReady) return;
            updateMagnifyingLensEngine(lens);
          });
          headerResizeObserver.observe(headerWidthSource);
        }

        lens.addEventListener('click', (event) => {
          if (event.target.closest('.magnifying-lens-cta')) return;

          const ripple = document.createElement('div');
          ripple.className = 'magnifying-lens-ripple';
          const rect = lens.getBoundingClientRect();
          ripple.style.cssText = `left:${event.clientX - rect.left}px;top:${event.clientY - rect.top}px;width:100px;height:100px;margin:-50px`;
          lens.appendChild(ripple);
          lens.classList.add('expanding', 'clicked');
          setTimeout(() => lens.classList.remove('expanding'), 300);
          setTimeout(() => {
            lens.classList.remove('clicked');
            ripple.remove();
          }, 600);
        });

        lens.addEventListener(
          'touchstart',
          (event) => {
            if (event.target.closest('.magnifying-lens-cta')) return;
            lens.classList.add('expanding');
          },
          { passive: true }
        );

        lens.addEventListener(
          'touchend',
          () => {
            setTimeout(() => lens.classList.remove('expanding'), 150);
          },
          { passive: true }
        );

        const stickyBuyBtn = document.getElementById('stickyBuyBtn');
        if (stickyBuyBtn) {
          stickyBuyBtn.addEventListener('click', () => {
            const checkoutBtn = document.getElementById('checkout');
            if (!checkoutBtn) return;
            if (checkoutBtn.disabled) return;
            checkoutBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => checkoutBtn.click(), 500);
          });
        }

        let resizeTimeout;
        let scrollFrame = null;
        const scheduleLensVisibilitySync = () => {
          if (scrollFrame !== null) return;

          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = null;
            syncLensVisibility();
          });
        };

        window.addEventListener('scroll', scheduleLensVisibilitySync, { passive: true });

        window.addEventListener(
          'resize',
          () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              lensReady = false;
              syncLensWidth();
              updateMagnifyingLensEngine(lens);
              lensReady = true;
              syncLensVisibility();
            }, 300);
          },
          { passive: true }
        );
      }

      if (document.readyState === 'complete') {
        setTimeout(initMagnifyingLens, 200);
      } else {
        window.addEventListener('load', () => setTimeout(initMagnifyingLens, 200), { once: true });
      }
    }

    const storageKey = 'cartDiscountCode';

    function readCode() {
      try {
        return sessionStorage.getItem(storageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function writeCode(value) {
      try {
        if (value) {
          sessionStorage.setItem(storageKey, value);
        } else {
          sessionStorage.removeItem(storageKey);
        }
      } catch (error) {
      }
    }

    function getDiscountRoot() {
      return document.querySelector('[data-cart-discount-root]');
    }

    function syncDiscountUi() {
      const discountRoot = getDiscountRoot();
      if (!discountRoot) return;

      const input = discountRoot.querySelector('[data-cart-discount-code]');
      const status = discountRoot.querySelector('[data-cart-discount-status]');
      const storedCode = readCode().trim();

      if (input && input.value !== storedCode) {
        input.value = storedCode;
      }

      if (!status) return;

      const nextStatus = storedCode
        ? discountRoot.dataset.discountAppliedTemplate.replace('__CODE__', storedCode)
        : discountRoot.dataset.discountHint;

      if (status.textContent !== nextStatus) {
        status.textContent = nextStatus;
      }
    }

    function getSummaryMagnifyingLens() {
      const summarySection = document.getElementById('main-cart-footer');
      if (!summarySection) return null;
      return summarySection.querySelector('#magnifyingLens');
    }

    function getFloatingMagnifyingLens() {
      return Array.from(document.querySelectorAll('#magnifyingLens')).find((lens) => lens.parentElement === document.body);
    }

    function syncMagnifyingLensUi() {
      const summaryLens = getSummaryMagnifyingLens();
      const floatingLens = getFloatingMagnifyingLens();
      const checkoutBtn = document.getElementById('checkout');
      const isCheckoutVisible = isElementVisibleInViewport(checkoutBtn);
      const summarySection = document.getElementById('main-cart-footer');
      const itemsSection = document.getElementById('main-cart-items');

      if (floatingLens) {
        const isSummaryBelowProducts =
          summarySection &&
          itemsSection &&
          summarySection.getBoundingClientRect().top >= itemsSection.getBoundingClientRect().bottom - 2;

        floatingLens.classList.toggle(
          'visible',
          Boolean(checkoutBtn && !checkoutBtn.disabled && isSummaryBelowProducts && !isCheckoutVisible)
        );
      }

      if (!summaryLens || !floatingLens || summaryLens === floatingLens) return;

      const sourcePrice = summaryLens.querySelector('.magnifying-lens-price');
      const targetPrice = floatingLens.querySelector('.magnifying-lens-price');

      if (sourcePrice && targetPrice && targetPrice.textContent !== sourcePrice.textContent) {
        targetPrice.textContent = sourcePrice.textContent;
      }

      const sourceButton = summaryLens.querySelector('#stickyBuyBtn');
      const targetButton = floatingLens.querySelector('#stickyBuyBtn');

      if (sourceButton && targetButton) {
        targetButton.disabled = sourceButton.disabled;

        if (sourceButton.disabled) {
          targetButton.setAttribute('disabled', '');
        } else {
          targetButton.removeAttribute('disabled');
        }
      }

      summaryLens.remove();
    }

    function subscribeToCartUpdates() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
        return;
      }

      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        syncDiscountUi();
        syncMagnifyingLensUi();
      });
    }

    function getCartForm() {
      return document.getElementById('cart');
    }

    function updateCartActionWithDiscount(form, discountCode) {
      if (!form) return;

      const baseAction = form.dataset.cartActionBase || form.getAttribute('action') || '/cart';
      form.dataset.cartActionBase = baseAction;

      const actionUrl = new URL(baseAction, window.location.origin);

      if (discountCode) {
        actionUrl.searchParams.set('discount', discountCode);
      } else {
        actionUrl.searchParams.delete('discount');
      }

      form.setAttribute('action', `${actionUrl.pathname}${actionUrl.search}${actionUrl.hash}`);
    }

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-cart-discount-code]');
      if (!input) return;

      const nextCode = input.value.trim();
      writeCode(nextCode);
      updateCartActionWithDiscount(getCartForm(), nextCode);
      syncDiscountUi();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('#cart');
      if (!form || event.submitter?.name !== 'checkout') return;

      updateCartActionWithDiscount(form, readCode().trim());
    });

    document.addEventListener('DOMContentLoaded', () => {
      updateCartActionWithDiscount(getCartForm(), readCode().trim());
      syncDiscountUi();
      syncMagnifyingLensUi();
    });
    subscribeToCartUpdates();
    updateCartActionWithDiscount(getCartForm(), readCode().trim());
    syncDiscountUi();
    syncMagnifyingLensUi();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    if (window.__cartRemoveConfirmBound) return;
    window.__cartRemoveConfirmBound = true;

    let pendingButton = null;
    let lastActiveElement = null;

    function getDialogRoot() {
      return document.getElementById('CartRemoveConfirm');
    }

    function closeDialog() {
      const dialogRoot = getDialogRoot();
      if (!dialogRoot) return;
      dialogRoot.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
      pendingButton = null;
      lastActiveElement = null;
    }

    document.addEventListener('cart:request-remove-confirmation', (event) => {
      const dialogRoot = getDialogRoot();
      if (!dialogRoot) return;

      pendingButton = event.detail.button;
      lastActiveElement = document.activeElement;
      const productTarget = dialogRoot.querySelector('[data-cart-remove-product]');
      if (productTarget) {
        productTarget.textContent = event.detail.title || '';
      }

      dialogRoot.hidden = false;
      document.body.classList.add('overflow-hidden');

      const confirmButton = dialogRoot.querySelector('[data-cart-remove-confirm]');
      if (confirmButton) confirmButton.focus();
    });

    document.addEventListener('click', (event) => {
      const cancelTrigger = event.target.closest('[data-cart-remove-cancel]');
      if (cancelTrigger) {
        event.preventDefault();
        closeDialog();
        return;
      }

      const confirmTrigger = event.target.closest('[data-cart-remove-confirm]');
      if (!confirmTrigger || !pendingButton) return;

      event.preventDefault();
      pendingButton.setAttribute('data-confirmed', 'true');
      pendingButton.click();
      closeDialog();
    });

    document.addEventListener('keydown', (event) => {
      const dialogRoot = getDialogRoot();
      if (!dialogRoot || dialogRoot.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
